/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_6Inputs */

const en_svr_guidance_onsite_6 = /** @type {(inputs: Svr_Guidance_Onsite_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who is the Accenture Field Operation Team POC?`)
};

const ja_svr_guidance_onsite_6 = /** @type {(inputs: Svr_Guidance_Onsite_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accentureフィールドオペレーションチームの担当者は誰ですか？`)
};

const fr_svr_guidance_onsite_6 = /** @type {(inputs: Svr_Guidance_Onsite_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui est le point de contact de l'équipe Accenture ?`)
};

const de_svr_guidance_onsite_6 = /** @type {(inputs: Svr_Guidance_Onsite_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer ist der Ansprechpartner des Accenture Field Operation Teams?`)
};

/**
* | output |
* | --- |
* | "Who is the Accenture Field Operation Team POC?" |
*
* @param {Svr_Guidance_Onsite_6Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_6 = /** @type {((inputs?: Svr_Guidance_Onsite_6Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_6Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_6(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_6(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_6(inputs)
	return de_svr_guidance_onsite_6(inputs)
});